module.exports = __webpack_public_path__ + "static/media/wuliupeisong1.21790b43.png";